import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "@/lib/api";
import { PageHeader, StatusBadge, Empty } from "@/components/shared";
import { Switch } from "@/components/ui/switch";

export default function AdminMerchants() {
  const [ms, setMs] = useState([]);
  const load = () => api.get("/admin/merchants").then((r) => setMs(r.data));
  useEffect(() => { load(); }, []);
  const toggle = async (m, active) => { try { await api.patch(`/admin/merchants/${m.id}`, { status: active ? "active" : "suspended" }); toast.success(active ? "Marchand réactivé" : "Marchand suspendu"); load(); } catch (e) { toast.error(errMsg(e)); } };
  const del = async (m) => { if (!window.confirm(`Supprimer définitivement ${m.name} et ses données ?`)) return; await api.delete(`/admin/merchants/${m.id}`); toast.success("Marchand supprimé"); load(); };

  return (
    <div>
      <PageHeader title="Marchands" subtitle="Créer (via inscription), suspendre ou supprimer des marchands. Un marchand suspendu ne peut plus se connecter ni créer de commandes." />
      {ms.length === 0 ? <Empty text="Aucun marchand inscrit." /> : (
        <div className="panel overflow-x-auto" data-testid="admin-merchants-table">
          <table className="w-full text-sm">
            <thead className="text-left text-xs text-zinc-500 border-b border-border"><tr><th className="p-3">Boutique</th><th className="p-3">Email</th><th className="p-3">Mode</th><th className="p-3">Commandes</th><th className="p-3">Sites</th><th className="p-3">Wallets</th><th className="p-3">Statut</th><th className="p-3">Inscrit</th><th className="p-3 text-right">Actif</th></tr></thead>
            <tbody>
              {ms.map((m) => (
                <tr key={m.id} className="border-b border-border/60" data-testid="admin-merchant-row">
                  <td className="p-3 font-medium">{m.name}</td><td className="p-3 text-xs text-zinc-400">{m.email}</td>
                  <td className="p-3 font-mono text-xs">{m.mode}</td><td className="p-3">{m.orders}</td><td className="p-3">{m.sites}</td><td className="p-3">{m.wallets}</td>
                  <td className="p-3"><StatusBadge status={m.status} /></td><td className="p-3 text-xs text-zinc-500">{fmtDate(m.created_at)}</td>
                  <td className="p-3 text-right"><div className="flex items-center justify-end gap-3"><Switch checked={m.status === "active"} onCheckedChange={(v) => toggle(m, v)} data-testid="admin-merchant-toggle-switch" /><button onClick={() => del(m)} className="text-zinc-500 hover:text-red-400" data-testid="admin-delete-merchant-btn"><Trash2 size={15} /></button></div></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
